import { capitalCase } from "change-case";

export class Filter {
  key: string;
  name: string;
  where: WhereOption;
  type: ValueType;
  value: string | number | null;

  constructor(
    key: string,
    name: string,
    where: WhereOption,
    value: string | number | null,
    type: ValueType
  ) {
    this.key = key;
    this.name = name;
    this.where = where;
    this.type = type;
    this.value = value;
  }

  description(): string {
    if (this.value) {
      return `${capitalCase(this.name)} ${this.where.label} ${this.value}.`;
    } else {
      return `${capitalCase(this.name)} ${this.where.label}.`;
    }
  }
}

export class FilterOption {
  key: string;
  label: string;
  type: ValueType;
  where: WhereOption[] = [];

  constructor(
    key: string,
    label: string,
    type: ValueType,
    where: WhereOption[]
  ) {
    this.key = key;
    this.label = label;
    this.type = type;
    this.where = where;
  }
}

export enum ValueType {
  DateTime = "datetime",
  None = "none",
  Number = "number",
  String = "string",
}

export class WhereOption {
  label: string;
  value: string;
  needsValue: boolean;

  static readonly contains = new WhereOption("contains", "CONTAINS", true);

  static readonly exists = new WhereOption("exists", "EXISTS", false);

  static readonly notExists = new WhereOption(
    "does not exist",
    "NOT_EXISTS",
    false
  );

  static readonly isAfter = new WhereOption("is after", "IS_AFTER", true);

  static readonly isBefore = new WhereOption("is before", "IS_BEFORE", true);

  static readonly isGreaterThan = new WhereOption(
    "is greater than",
    "IS_GREATER_THAN",
    true
  );

  static readonly isGreaterThanOrEqual = new WhereOption(
    "is greater than or equal to",
    "IS_GREATER_THAN_OR_EQUAL",
    true
  );

  static readonly isLessThan = new WhereOption(
    "is less than",
    "IS_LESS_THAN",
    true
  );

  static readonly isLessThanOrEqual = new WhereOption(
    "is less than or equal to",
    "IS_LESS_THAN_OR_EQUAL",
    true
  );

  static readonly matchesExactly = new WhereOption(
    "matches exactly",
    "MATCHES_EXACTLY",
    true
  );

  static readonly notContains = new WhereOption(
    "does not contain",
    "NOT_CONTAINS",
    true
  );

  constructor(label: string, value: string, needsValue: boolean) {
    this.label = label;
    this.value = value;
    this.needsValue = needsValue;
  }
}
